<template>
  <div class="h-layout" @click="onchange">
    <div class="check-box-outer">
      <img v-if="value" :src="src" style="width: 12px; height: 12px;" />
    </div>
    <label class="ml-2 lbl_default" :style="fontStyle">{{label}}</label>
  </div>
</template>

<script>
export default {
  name: "CheckBox",
  props:{
    value:{
      type:Boolean,
      default:false,
    },
    label: String,
    fontStyle: String,
  },
  methods:{
    onchange(){
      // this.$emit('input', !this.value);
      this.$emit('onChange', !this.value);
    }
  },
  computed:{
    src(){
      return this.value ?
          '/assets/new/ic_check.png'
          :
          '';
    }
  },
}
</script>

<style scoped lang="scss">
.check-box-outer {
  background-image: url("/assets/new/ic_check_off.png");
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
}
</style>